import { Box, CircularProgress } from '@material-ui/core';
import { User } from '@nemuru-eng/js-api-client';

import { useUserActions } from '@/components/shared/components/UserList/hooks/useUserActions';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const BlockAllUsersMessage = ({
  userId,
  users,
  opened,
  setOpened,
  handleClose,
}: {
  userId: string;
  users: User[];
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}) => {
  const { patchBlockUsersAndGetUsersByUserId, loading } = useUserActions({ userId });
  const nonBlockedUsers = users.filter((user) => user.isBlocked === false);

  const onBlockAllUsers = async () => {
    await patchBlockUsersAndGetUsersByUserId({
      users: nonBlockedUsers,
    });
    handleClose();
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton disabled={loading} main onClick={() => onBlockAllUsers()}>
            {loading ? <CircularProgress size={20} color={'secondary'} /> : <Text tId={'BLOCK_ALL_USERS'} />}
          </StandardButton>
        </>
      }
    >
      <>
        <Box marginBottom={2}>
          <Font variant="h3" color="textPrimary">
            <Text tId={'BLOCK_ALL_USERS'} />
          </Font>
        </Box>
        <Box pt={3}>
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={'DO_YOU_WANT_TO_BLOCK_THE_FOLLOWING_USERS'} />
            {nonBlockedUsers?.length > 0 &&
              nonBlockedUsers.map((nonBlockedUser) => (
                <Font variant={'body2'}>
                  <li style={{ paddingTop: '8px' }}>{nonBlockedUser.username}</li>
                </Font>
              ))}
          </Font>
        </Box>
      </>
    </NemuruDialog>
  );
};
